module.exports = __webpack_public_path__ + "img/image336.d678f51b.png";